import { render, staticRenderFns } from "./StorageFee.vue?vue&type=template&id=3140b186&scoped=true&"
import script from "./StorageFee.vue?vue&type=script&lang=js&"
export * from "./StorageFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140b186",
  null
  
)

export default component.exports